import type { schemaType as detailSchemaType } from '~/modules/api/rurality/v3/cottage-deals/cottage/detail/schema'
import type { propsInterface } from '~/modules/design-system/sections/s-deals.vue'
import { format, parseISO } from 'date-fns'

const dateFormat = 'dd/MM/yy'

const formatDate = (input: string) => {
  if (isNaN(parseISO(input).getTime())) {
    return input
  } else {
    return format(parseISO(input) as Date, dateFormat)
  }
}

export const useToSDeals = () => {
  const fromRuralityCottageDealsDetail = (params: {
    dataIn: detailSchemaType
    province: string
    slug: string
  }): propsInterface => {
    let items: propsInterface['items'] = []

    items = params.dataIn.deals.map(item => {
      const itemMapped: propsInterface['items'][0] = {
        title: item.title,

        description: item.description,

        percentage: Math.round(item.percentage),
        whatIncludes: item.whatIncludes,
        total: toEuro(item.total.amount),
        totalOld: toEuro(item.totalOld.amount),

        dateIn: formatDate(item.dateIn),
        dateOut: formatDate(item.dateOut),

        nights: item.nights,
        people: item.people,
        pricePersonNight: toEuro(item.pricePersonNight.amount),

        slug: params.slug,
        province: params.province,
        id: item.id,
      }

      return itemMapped
    })

    return { items }
  }

  return {
    fromRuralityCottageDealsDetail,
  }
}
